<template>
  <article class="justify-between align-values-start">
    <section>
      <header><strong>{{ name }}</strong></header>

      <ul class="list-unstyled">
        <li
            v-for="service in services"
            :key="service.id"
            class="small"
        >
          {{ service.formatted_string }}

          <template v-if="service.notice || (service.info && service.info.notice)">
            |
            {{ service.notice || service.info.notice }}
          </template>
        </li>
      </ul>
    </section>

    <b-button-group tag="aside">
      <template v-if="$gate.allow('create', value.model_name)">
        <duplicate-modal
            :api-url="`${apiUrl}/${value.id}/duplicate`"
            :value="value"
            hide-locations
            @duplicated="$emit('created', $event)"
        >
          <template #activator="{duplicating, show}">
            <b-button
                :disabled="duplicating"
                :title="$t('Duplicate')"
                style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                @click="show()"
            >
              <fa :spin="duplicating" fixed-width icon="copy"/>
              <span class="sr-only">{{ $t('Duplicate') }}</span>
            </b-button>
          </template>

          <template #options="{options}">
            <hr>

            <b-form-checkbox
                id="services"
                v-model="options.withServices"
                class="ml-3"
            >
              {{ $t('Duplicate with services') }}
            </b-form-checkbox>
          </template>
        </duplicate-modal>
      </template>

      <b-button
          v-if="$gate.allow('update', value)"
          :disabled="pending || pendingDelete"
          :title="$t('Edit {0}', [value.name])"
          :to="{name: 'projects.foundations.show', params: {projectId: value.project_id, id: value.id}}"
          variant="primary"
      >
        <fa
            :spin="pending"
            icon="edit"
        />
      </b-button>

      <!-- Delete -->
      <b-button
          v-if="$gate.allow('delete', value)"
          :disabled="pending || pendingDelete || value.deleted_at"
          :title="$t('Delete {0}', [value.name])"
          variant="danger"
          @click="handleDelete"
      >
        <fa
            :spin="pendingDelete"
            icon="trash"
        />
      </b-button>

      <!-- Restore -->
      <b-button
          v-if="$gate.allow('restore', value)"
          :disabled="value.deleted_at === null"
          :title="$t('Restore {0}', [value.name])"
          variant="success"
          @click="handleRestore()"
      >
        <fa
            :spin="pendingDelete"
            icon="recycle"
        />
      </b-button>

    </b-button-group>
  </article>
</template>
<script>
import DuplicateModal from "@/components/DuplicateModal";

export default {
  name: 'ProjectFoundationListItem',
  components: {DuplicateModal},
  props: {
    value: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      pendingDelete: false,
      showUpdateModal: false,
    };
  },
  computed: {
    services() {
      if (!this.value.services) return [];
      return this.value.services.filter(service => service);
    },

    name() {
      let output = this.value.name;
      if (this.value.type) {
        output += ` ( ${this.$t(this.value.type)} )`
      }
      return output
    }
  },
  methods: {
    async handleDelete() {
      if (!confirm(this.$t('Are you sure?'))) {
        return;
      }

      this.pendingDelete = true;

      try {
        await this.axios.delete(this.apiUrl + '/' + this.value.id);
        this.$emit('deleted', this.value);
      } catch (e) {
      }

      this.pendingDelete = false;
    },

    async handleRestore() {
      this.pendingDelete = true;

      try {
        const {data} = await this.axios.post(this.apiUrl + '/' + this.value.id + '/restore');
        this.$emit('input', data);
      } catch (e) {
      }

      this.pendingDelete = false;
    },
  },
};
</script>
